import { render, staticRenderFns } from "./PaginatorCenter.vue?vue&type=template&id=7074da35&scoped=true&"
import script from "./PaginatorCenter.vue?vue&type=script&lang=js&"
export * from "./PaginatorCenter.vue?vue&type=script&lang=js&"
import style0 from "./PaginatorCenter.vue?vue&type=style&index=0&id=7074da35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074da35",
  null
  
)

export default component.exports